import { format, isSameDay } from 'date-fns'
import { toDateOrNull } from './common'

export const formatMessageTime = (value) => {
  const parsedDate = toDateOrNull(value)
  if (!parsedDate) return ''
  return format(parsedDate, 'hh:mm a')
}

export const getMessageDateKey = (value) => {
  const parsedDate = toDateOrNull(value)
  if (parsedDate) return format(parsedDate, 'yyyy-MM-dd')
  return (value || '').toString().slice(0, 10)
}

export const formatChatroomLastMessageTime = (value, formatGeneralDate) => {
  const parsedDate = toDateOrNull(value)
  if (!parsedDate) return ''
  return isSameDay(parsedDate, new Date())
    ? format(parsedDate, 'hh:mm a')
    : formatGeneralDate(parsedDate)
}
